module.exports = "/images/vendor/leaflet-fullscreen/dist/fullscreen.png?ddb8362e333c8f3225da9d578d00c14c";